import { Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ShiftDetailHeadFlexPoolsProps } from './shift-detail-head-flex-pools.types';

export const ShiftDetailHeadFlexPools = ({ flexPools }: ShiftDetailHeadFlexPoolsProps) => {
  const { t } = useTranslation('web-common');
  const title = flexPools.length > 0 ? flexPools.map((pool) => pool.name).join(', ') : null;

  return (
    <Tooltip title={title}>
      <Typography noWrap variant="subtitle2">
        {t('shift-detail-head.flex-pools.label', { count: flexPools.length })}
      </Typography>
    </Tooltip>
  );
};
